module.exports = __webpack_public_path__ + "img/c845348.png";